// @flow
import { EstimatesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    listaEstimates: [],
    estimate: {},
    loading: false,
    error: false,
    loadingList: false,
    errorList: false,
    formSubmited: false
};

type EstimatesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { estimate?: {} | null, listaEstimates?: [] | null, loading?: boolean, +value ?: boolean };

const Estimates = (state: State = INIT_STATE, action: EstimatesAction): any => {
    // console.log(action);
    switch (action.type) {
        case EstimatesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EstimatesActionTypes.CREATE_ESTIMATE: {
                    return {
                        ...state,
                        estimate: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT: {
                    return {
                        ...state,
                        listaEstimates: action.payload.data,
                        errorList: false,
                        loadingList: false
                    }
                }
                default:
                    return { ...state };
            }

        case EstimatesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {

                case EstimatesActionTypes.CREATE_ESTIMATE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        estimate: {},
                        loading: false,
                        formSubmited: true
                    };
                }
                case EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT: {
                    return {
                        ...state,
                        errorList: true,
                        loadingList: false,
                        listaEstimates: []
                    }
                }
                default:
                    return { ...state };
            }

        case EstimatesActionTypes.CREATE_ESTIMATE:
            return { ...state, error: false, errorList: false, loading: true, loadingList: false };
        case EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT:
            return { ...state, error: false, errorList: false, loading: false, loadingList: true }
        case EstimatesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                loadingList: false,
                errorList: false,
                estimate: {},
                listaEstimates: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Estimates;
